import React from 'react';
import PropTypes from 'prop-types';

import './Notification.scss';

export default function Notification({ children, onClose, type }) {
  return (
    <div className={`Notification--${type}`} onClick={onClose}>
      {children}
    </div>
  );
}

Notification.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['info', 'success', 'warn', 'danger']).isRequired,
};

Notification.defaultProps = {
  onClose() {},
};
